import { SummerExtrasStartOrderClickEvent } from '@/services/analytics/events';
import { AdobeBaseEvent }                   from './adobe-base-event';
import { AnalyticsEventType }               from '../models';
import { Store }                            from 'vuex';
import { AppState }                         from '@/store';
import { ServicesContainer }                from '@/services';

export class AdobeSummerExtrasStartOrderClickEvent extends AdobeBaseEvent {
  name  = 'AdobeSummerExtrasStartOrderClickEvent';
  event = AnalyticsEventType.LinkClicked;

  constructor(
    event: SummerExtrasStartOrderClickEvent,
    store: Store<AppState>,
    services: ServicesContainer
  ) {
    super(store, services);

    this.web.webInteraction = {
      linkCategory: 'order-menu',
      linkClicks:   { value: 1 },
      linkName:     'start an order',
      linkSection:  'extras-summer-of-extras',
      linkTitle:    event.linkTitle,
      name:         'start an order',
      type:         'other'
    };

    this.web.webPageDetails = {
        language:   'en-us',
        name:       'rewards:extras:summer-of-extras',
        pageType:   'rewards',
        siteRegion: 'US',
        siteSection:'rewards'
      };
  }
}
